import React from "react";
import { CardSelection } from "../../components/topcoin/CardSelection";
import { useAppContext } from "../../contexts/AppContext";

export default function PurchasePage() {
  const { addToCart } = useAppContext();

  return (
    <div className="purchase-page" style={{ backgroundColor: 'rgb(249, 250, 251)', minHeight: '100vh', margin: 0, padding: 0 }}>
      <div className="py-12" style={{ padding: '3rem 0', minHeight: '60vh' }}>
        <CardSelection onAddToCart={(tier) => addToCart({ ...tier, qty: 1 })} />
      </div>
    </div>
  );
}
